import { api } from "./authService"
import { CruiseData, CruiseDataParams } from "../models/cruiseData.model"

export async function getCruiseData(
	params: CruiseDataParams
): Promise<CruiseData> {
	try {
		const { agencyId, countryCode, currencyCode, internationalRepFlag } = params

		const { data } = await api.get<{ data: CruiseData }>(
			"/userProfile/cruise-data",
			{
				params: {
					agencyId,
					countryCode,
					currencyCode,
					internationalRepFlag
				}
			}
		)

		return data.data
	} catch (error) {
		console.error("Error fetching cruise data:", error)
		throw new Error("Error fetching cruise data")
	}
}
